import { moduleState, props, state } from 'cerebral'
import { set, when } from 'cerebral/factories'
import { descend, path } from 'ramda'
import { saveEntities, saveListView, sortEntityList, useStoredSkip } from '../factories'
import { showFeedback } from '../feedback/factories'
import { sequences as route } from '../route'
import * as actions from './actions'

export const find = [
  when(state`account.packages`, (packages) => packages.people || packages.rsvps),
  {
    true: [
      //
      actions.find,
      saveEntities(),
      actions.saveMobileUserMapping,
    ],
    false: [
      //
      set(props`result.ids`, []),
    ],
  },
]

export const findForList = [
  //
  set(props`useRouteParams`, true),
  useStoredSkip,
  actions.adjustFilters,
  actions.find,
  actions.setList,
  saveListView('toPeople'),
  saveEntities(),
  actions.saveMobileUserMapping,
]

export const loadById = [
  //
  actions.loadById,
  find,
]

export const get = [
  //
  actions.get,
  saveEntities(),
]

export const save = [
  //
  actions.save,
  actions.clearList,
  saveEntities(),
  showFeedback({ title: 'Profile saved', type: 'success' }),
  ({ props: { entities } }) => {
    const [result] = entities.profiles
    // Redirect back to appropriate user.
    return { params: { id: result?._id } }
  },
  route.toPerson,
]

export const saveWithoutFeedback = [
  //
  actions.save,
  saveEntities(),
]

export const updateUserTypes = [
  //
  actions.updateUserTypes,
  saveEntities(),
  showFeedback({ title: 'User roles updated', type: 'success' }),
]

export const updateRequestedUserTypes = [
  //
  actions.updateRequestedUserTypes,
  saveEntities(),
  showFeedback({ title: 'User role requests updated', type: 'success' }),
]

export const getProfilesRequestingRoles = [
  when(state`account.currentUser.canAccessCommandCenter`),
  {
    true: [
      //
      set(props`query.filter`, 'requesting'),
      find,
      set(moduleState`requestingRoleIds`, props`result.ids`),
    ],
    false: [],
  },
]

export const handleServerUpdate = [
  //
  actions.manageProfileRequestingRoles,
  saveEntities(),
  // Only sort if the changed profile is in the connection board list.
  when(moduleState`connectionBoardList.ids`, props`profile._id`, (ids, id) => ids?.includes(id)),
  {
    true: sortEntityList({ sortComparator: descend(path(['connectionScore', 'total'])), entityType: 'profiles', listKey: 'connectionBoardList' }),
    false: [],
  },
]

export const patch = [
  //
  actions.patch,
  saveEntities(),
]

export const remove = [
  //
  actions.remove,
  showFeedback({ title: 'Profile removed', type: 'success' }),
  findForList,
]

export const reactivate = [
  //
  actions.reactivate,
  showFeedback({ title: 'Profile reactivated', type: 'success' }),
  findForList,
]

export const getTodaysBirthdays = [
  //
  when(state`account.currentUser.canAccessCommandCenter`),
  {
    true: [
      when(state`account.packages`, (packages) => packages.people || packages.rsvps),
      {
        true: [
          //
          actions.getTodaysBirthdays,
          saveEntities(),
        ],
        false: [],
      },
    ],
    false: [],
  },
]

export const acknowledgeBirthday = [
  //
  actions.acknowledgeBirthday,
  actions.getTodaysBirthdays,
  saveEntities(),
  when(state`route.path`, (path) => path.includes('update')),
  {
    true: [],
    false: [
      //
      showFeedback({ title: 'Birthday has been dismissed', type: 'success' }),
    ],
  },
]

export const setLevelOfCare = [
  //
  actions.setLevelOfCare,
]

export const setColumns = [
  //
  set(state`profiles.columns.${props`role`}`, props`columns`),
]

export const checkDuplicates = [
  //
  actions.checkDuplicates,
]

export const setInactiveResidents = [
  //
  set(props`params`, { filter: 'connectionBoardInactive' }),
  route.toRoot,
]
